import React from 'react';
import { useState,useEffect } from 'react';
import Popup from './Popup';
import './LiveRfqs.css'
import {useHistory} from 'react-router-dom'
import closed from '../images/Closed.webp'
import { getAllTheRfqs } from '../service/api';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import image_32 from '../images/image_32.png';
import image_33 from '../images/image_33.png';


function LiveRfqs() {
    const [isOpenRfqs,setIsOpenRfqs]=useState(false);
    const [openSnackBar,setOpenSnackBar]=useState(false);
    const [severity,setSeverity]=useState("");
    const [msg,setMsg]=useState("");
    const [numberItems,setNumberItems]=useState(2);
    const posts = [
        {
            Title:"Nagpur Operations",
            EstimatedMonthlyVolume:"100 Tones",
            ServiceType:"Per kg Basis",
            CloseDate:"01/02/2023",
            imgsrc:'/images/Marico.webp',
            CompanyName:"Marico Pvt Ltd",
            closedImage:{closed}
        },
        {
            Title:"Bhiwandi Adhoc lanes",
            EstimatedMonthlyVolume:"560 Tones",
            ServiceType:"Per kg Basis",
            CloseDate:"25/01/2023",
            imgsrc:'/images/exide.png',
            CompanyName:"Exide",
            closedImage:{closed}
        }
    ];
    // const [posts,setPosts]=useState([]);
    const history=useHistory();

    // useEffect(() => {
    //         try{
    //             getAllTheRfqs().then((response)=>{setPosts(response.data)
    //             console.log(response.data);
    //             })    
    //         }
    //         catch(err){
    //             setOpenSnackBar(true);
    //             setSeverity("error");
    //             setMsg(err);
    //         }
        
    // }, [ ])

    function handlerFunction(){
        history.push("/RFQ")
    }

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };

    // function handleViewMore(e){
    //     if(e.length<numberItems+2){
    //         setNumberItems(e.length);
    //     }
    //     else{
    //         setNumberItems(numberItems+2);
    //     }
    // }
    // function handleViewLess(){
    //     setNumberItems(2);
    // }

  return (
    <>
    <div className='LiveRfqArea'>
        { posts.slice(0,numberItems).map((element)=>{
            return (
        <div id='liverfq'>
            <div className='left-column' onClick={()=>setIsOpenRfqs(true)}>
                    <h4><strong>RFQ : </strong>{element.Title}</h4>
                    <div className='left-column-division'>
                        <div>
                            <img src={closed} alt="Closed RFQ" style={{width:'80px',height:'70px',marginTop:'15px'}} />
                        </div>
                        <div className='rfqinfo'>
                            <p><strong>Monthly Volume :</strong>{element.EstimatedMonthlyVolume}</p>
                            <p><strong>Service Type :</strong>{element.ServiceType}</p>
                            <p><strong>Last Date :</strong>{element.CloseDate}</p>
                        </div>
                </div>
            </div>
            <div className='right-column'>
                <img src={element.imgsrc} alt="Logo" className='logoRfq' style={{width:'95px',height:'35px'}} onClick={()=>setIsOpenRfqs(true)}/>
                <h6 onClick={()=>setIsOpenRfqs(true)}><strong>{element.CompanyName}</strong></h6>
                <div className='liverfqbut'>
                    <button className='status' onClick={()=>setIsOpenRfqs(true)}>Status</button>
                    <button className='apply' onClick={handlerFunction}>Apply</button>
                </div>
            </div>
            <Popup  trigger={isOpenRfqs} setTrigger={setIsOpenRfqs} style="popup-inner">
                        
                <div className='RFQCLOSED'>
                    <h2 style={{borderBottom: '3px solid rgba(0, 0, 0, 0.15)'}}><strong>RFQ Closed</strong></h2>
                    <div className='RfqClosedPopup'>
                        <img src={image_32} alt="cross" style={{width:'50px'}}/>
                        <div>
                            <h3>This RFQ has been closed</h3>
                            <h6>Last Date was on 16/1/2022</h6>
                        </div>
                    </div>
                    <div className='RfqSymbolPopup'>
                        <img src={image_33} alt="symbol" style={{width:'50px'}}/>
                        <h3><strong>You will be notified whenever a new RFQ is floated</strong></h3>
                    </div>
                    <button className='RfqPopupSub' onClick={()=>setIsOpenRfqs(false)} >Sure</button>
                </div>
            </Popup>
        </div>
        )
        })
    }
        </div>
        {/* <div className='viewButtonArea'>
            <button className='viewbutton' onClick={()=>{handleViewMore(posts)}}>View More</button>
            <button className='viewbutton' onClick={()=>{handleViewLess()}}>View Less</button>
        </div> */}
        <Snackbar
            anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
            open={openSnackBar}
            autoHideDuration={8000}
            onClose={handleClose}
            >
            <Alert onClose={handleClose} severity={severity}>
                {msg}
            </Alert>
          </Snackbar>
    </>
  
  )}

export default LiveRfqs;
